import {
    modalContent, modalHeader,
} from './styles'

import AudienceMetadata from 'components/AudienceMetadata'
import Button from 'components/Button'
import {MetadataModalProps} from './types'
import Modal from '../Modal'
import {
    ModalFooter,
} from '../ModalView'
import React from 'react'
import User from 'components/User'

import {styled} from 'stitches/config'
import {
    useTranslation,
} from 'react-i18next'

const StyledModalContent = styled('div', modalContent)
const StyledModalHeader = styled('div', modalHeader)

const MetadataPromiseModalView = (props: MetadataModalProps): React.ReactElement => {
    const {
        onReject, channelId, userId, sso, secure, agentIds, realmId,
    } = props
    const {t} = useTranslation()

    const handleCloseModal = () => {
        // eslint-disable-next-line no-unused-expressions
        onReject && onReject()
    }
    return (
        <Modal onClose={handleCloseModal} type='metadata'>
            <StyledModalHeader>
                <User displayProtectedEmail={true} fallbackName={(sso?.['First name'] || secure?.claims?.preferred_username) as string} size='small' userId={userId || ''} />
            </StyledModalHeader>
            <StyledModalContent>
                <AudienceMetadata
                    agentIds={agentIds}
                    channelId={channelId}
                    lite
                    realmId={realmId}
                    showOnlyOneUserId={userId}
                />
            </StyledModalContent>
            <ModalFooter>
                <Button color='filled' onPress={handleCloseModal} size='large' tabIndex={-1} text={t('Close')} />
            </ModalFooter>
        </Modal>
    )
}

export default MetadataPromiseModalView
